import styles from "../../../style/instacheck.module.css";

const GoBeyondRarity = ({ theme }) => {
	const color = theme === "light" ? "#282d41" : "#fff";

	return (
		<a
			href="https://www.beyondrarity.com"
			target="_blank"
			rel="noreferrer"
			title="Go Beyond Rarity - https://www.beyondrarity.com"
		>
			<div class={styles.goBR}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 336.66 26.24"
					alt="Go Beyond Rarity"
				>
					<defs>
						<radialGradient
							id="radial-gradient"
							cx="-224.15"
							cy="79.63"
							r="1"
							gradientTransform="matrix(14.81 0 0 -14.81 3525.59 1185.97)"
							gradientUnits="userSpaceOnUse"
						>
							<stop offset="0" stopColor="#f99b20" />
							<stop offset="1" stopColor="#e0078c" />
						</radialGradient>
						<clipPath id="clip-path">
							<path
								style={{ fill: color, opacity: 0.5 }}
								d="M189.56 7.77 205 26.24V13.68a5.92 5.92 0 0 0-6-5.91Zm23.17 0a5.92 5.92 0 0 0-5.92 5.91v12.56l15.4-18.47ZM195.59 0l-5.92 5.92H199A5.93 5.93 0 0 0 204.92 0Zm11.25 0a5.93 5.93 0 0 0 5.92 5.92h9.33L216.17 0Z"
							/>
						</clipPath>
					</defs>

					<path
						fill={color}
						d="M292.28 2.76h3.64v12.69h-3.64zM331.73 2.75l-5.5 4.91-5.51-4.91h-22.41v3.14h8.17v9.56h3.64V5.89h9.37l4.91 4.53v5.03h3.65v-5.01l8.61-7.69h-4.93zM262.3 2.75h-7.79l-6.8 12.7h3.93l5.03-9.53h3.5l5.02 9.53h3.92l-6.81-12.7zM246.53 6.85a4.11 4.11 0 0 0-4.1-4.1h-15.09a3.16 3.16 0 0 0 3.16 3.17h11.73a.93.93 0 1 1 0 1.86H230.5a3.16 3.16 0 0 0-3.16 3.16v4.51h3.55v-4.51h8.23l2.67 4.51H246l-3-4.55a4.1 4.1 0 0 0 3.52-4.05M290 6.85a4.1 4.1 0 0 0-4.09-4.1h-15.1A3.17 3.17 0 0 0 274 5.92h11.73a.93.93 0 1 1 0 1.86H274a3.16 3.16 0 0 0-3.17 3.16v4.51h3.55v-4.51h8.23l2.68 4.51h4.19l-3-4.55A4.1 4.1 0 0 0 290 6.85"
					/>
					<g clipPath="url(#clip-path)">
						<path fill="url(#radial-gradient)" d="M189.56 0h32.65v26.24h-32.65z" />
					</g>
					<path
						fill={color}
						d="M95.3 12.29H81.16v-1.87h12.85V7.78H81.16V5.92H95.3V2.75H77.51v12.7H95.3v-3.16zM113.29 2.75l-5.5 4.57-5.51-4.57h-4.91l8.59 7.33v5.37h3.65V10.1l8.61-7.35h-4.93zM141.75 2.75v12.7h3.57V6.97l12.98 8.48h3.74V2.75h-3.56v8.49L145.5 2.75h-3.75zM132.75 2.53h-7.54c-4.11 0-7 2.7-7 6.57s2.88 6.57 7 6.57h7.54c4.11 0 7-2.7 7-6.57s-2.88-6.57-7-6.57m0 9.75h-7.54a3.12 3.12 0 0 1-3.27-3.19 3.12 3.12 0 0 1 3.27-3.2h7.54a3.13 3.13 0 0 1 3.25 3.2 3.13 3.13 0 0 1-3.27 3.19M177.53 2.75h-13.09v12.7h13.09c4.19 0 7-2.55 7-6.35s-2.82-6.35-7-6.35m0 9.53h-9.48V5.92h9.47a3.18 3.18 0 1 1 0 6.36M75.5 6.59a3.84 3.84 0 0 0-3.84-3.84h-16v12.7h16a3.84 3.84 0 0 0 3.84-3.84 3.79 3.79 0 0 0-1-2.51 3.79 3.79 0 0 0 1-2.51m-4.65 5.69H59.22v-1.86h11.63a.93.93 0 0 1 0 1.86m0-4.5H59.22V5.92h11.63a.93.93 0 0 1 0 1.86"
					/>
					<path
						style={{ fill: color, opacity: 0.5 }}
						d="M37.35 12.29h-7.54a3.13 3.13 0 0 1-3.27-3.2 3.12 3.12 0 0 1 3.27-3.2h7.54a3.12 3.12 0 0 1 3.27 3.2 3.13 3.13 0 0 1-3.27 3.2m0-9.76h-7.54c-4.12 0-7 2.7-7 6.57s2.87 6.58 7 6.58h7.54c4.12 0 7-2.71 7-6.58s-2.87-6.57-7-6.57M17.54 7.78h-6a2.65 2.65 0 0 0 2.65 2.64H17.59a3.15 3.15 0 0 1-3 1.89H7a3.13 3.13 0 0 1-3.27-3.2A3.12 3.12 0 0 1 7 5.89h13.74a6.77 6.77 0 0 0-6.21-3.36H7c-4.12 0-7 2.7-7 6.57s2.87 6.58 7 6.58h7.54c4.12 0 7-2.71 7-6.58a7 7 0 0 0-.13-1.32Z"
					/>
				</svg>
			</div>
		</a>
	);
};

export default GoBeyondRarity;
